export const MRCS = [
  {
    mrc: "MRC des Laurentides",
    villes: [
      "Mont-Tremblant", "Sainte-Agathe-des-Monts",
      "Ivry-sur-le-Lac", "Lac-Supérieur", "Ivry",
      "Saint-Faustin-Lac-Carré", "Val-David", "Val-des-Lacs", "Val-Morin",
    ],
  },
  {
    mrc: "MRC Thérèse-De Blainville",
    villes: [
      "Blainville", "Bois-des-Filion", "Boisbriand", "Lorraine", "Rosemère",
      "Sainte-Thérèse",
    ],
  },
  {
    mrc: "MRC de Deux-Montagnes",
    villes: [
      "Deux-Montagnes", "Oka", "Pointe-Calumet", "Saint-Eustache",
      "Saint-Joseph-du-Lac", "Sainte-Marthe-sur-le-Lac", "Mirabel",
    ],
  },
  {
    mrc: "MRC La Rivière-du-Nord",
    villes: [
      "Prévost", "Saint-Colomban", "Saint-Hippolyte", "Saint-Jérôme",
      "Sainte-Sophie",
    ],
  },
  {
    mrc: "MRC Les Pays-d'en-Haut",
    villes: [
      "Estérel", "Lac-des-Seize-Îles", "Morin-Heights", "Piedmont",
      "Saint-Adolphe-d'Howard", "Saint-Sauveur", "Sainte-Adèle",
      "Sainte-Anne-des-Lacs", "Sainte-Marguerite-du-Lac-Masson",
    ],
  },
  {
    mrc: "Rive-Nord",
    villes: [
      "Terrebonne", "La Plaine", "Sainte-Anne-des-Plaines", "Saint-Calixte",
    ],
  },
];

export function slugify(nom) {
  return nom
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export const VILLES = MRCS.flatMap((g) =>
  g.villes.map((nom) => ({ nom, mrc: g.mrc }))
);

export function villeParSlug(slug) {
  const index = VILLES.findIndex((v) => slugify(v.nom) === slug);
  if (index === -1) return null;
  return { ...VILLES[index], index };
}

export function villesVoisines(mrc, nomActuel) {
  const groupe = MRCS.find((g) => g.mrc === mrc);
  if (!groupe) return [];
  return groupe.villes.filter((v) => v !== nomActuel).slice(0, 8);
}
